import { render, staticRenderFns } from "./EmailConfirm.vue?vue&type=template&id=33bd5e9d&scoped=true&"
import script from "./EmailConfirm.vue?vue&type=script&lang=js&"
export * from "./EmailConfirm.vue?vue&type=script&lang=js&"
import style0 from "./EmailConfirm.vue?vue&type=style&index=0&id=33bd5e9d&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bd5e9d",
  null
  
)

/* custom blocks */
import block0 from "./EmailConfirm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports